import { LanguageKeys } from 'src/common/constants/languages';
import { EOrder } from 'src/interfaces/Order';
import { PublishedFilter, matchesPublishedFilter } from 'src/helpers/publishedFilter';
import { TechnicalType } from 'src/interfaces/TechnicalType';

export type TechnicalTypeSortBy = 'name' | 'label';

type TechnicalTypeFilterOptions = {
  query: string;
  publishedFilter: PublishedFilter;
  sortBy: TechnicalTypeSortBy;
  sortOrder: EOrder;
};

function matchesQuery(item: TechnicalType, query: string, _lang: LanguageKeys): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  if (item.name.toLowerCase().includes(q)) return true;
  return Object.values(item.i18n).some(value => value?.toLowerCase().includes(q));
}

export function filterTechnicalTypes(
  items: TechnicalType[],
  lang: LanguageKeys,
  { query, publishedFilter, sortBy, sortOrder }: TechnicalTypeFilterOptions,
): TechnicalType[] {
  let result = items.filter(item => {
    if (!matchesPublishedFilter(item.published, publishedFilter)) return false;
    return matchesQuery(item, query, lang);
  });

  result = [...result].sort((a, b) => {
    const aVal = sortBy === 'label' ? a.i18n[lang] ?? a.name : a.name;
    const bVal = sortBy === 'label' ? b.i18n[lang] ?? b.name : b.name;
    const cmp = aVal.localeCompare(bVal, undefined, { sensitivity: 'base' });
    return sortOrder === EOrder.desc ? -cmp : cmp;
  });

  return result;
}
